(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("wfs-mesh", [], factory);
	else if(typeof exports === 'object')
		exports["wfs-mesh"] = factory();
	else
		root["wfs-mesh"] = factory();
})(self, function() {
return 